import { useState } from "react";
import TypeFreeContent from "./SubAddFreeContent/TypeFreeContent";
import SocialNetwork from "./SubAddFreeContent/SocialNetwork";
import BoxInput from "./SubAddFreeContent/BoxInput";
import DescriptionContent from "./SubAddFreeContent/DescriptionContent";
import ModalTitleButton from "../../SubDashboard/ModalTitleButton/ModalTitleButton";

function AddFreeContent({ closeModal }) {

    const [typeContent, setTypeContent] = useState("")
    const [socialNetwork, setSocialNetwork] = useState("")
    const [titleContent, setTitleContent] = useState("")
    const [link, setLink] = useState("")

    return (
        <>
            <div className="fixed top-0 left-0 bg-black w-screen h-screen opacity-40"></div>
            <div className="bg-slate-100 w-1/3 fixed top-16 left-1/3 rounded-lg shadow pb-10">
                <ModalTitleButton
                    text="ثبت"
                    closeModal={closeModal}
                >
                    <div className="flex flex-row-reverse mx-2 mb-4 px-12 mt-10">
                        <img src="/image/icon/freeContent/addContent.png" className="w-12 mb-4" />
                        <div className="text-right mr-4">
                            <p className="t-purpleDark font-bold text-lg mb-1">ثبت محتوای جدید</p>
                            <p className="text-xs text-slate-400">لطفا تمامی اطلاعات مربوط به محتوای آزاد جدید را به درستی وارد نمایید</p>
                        </div>
                    </div>
                    <div className="px-12 mb-4">
                        <TypeFreeContent typeContent={typeContent} chooseType={setTypeContent} />
                        <SocialNetwork socialNetwork={socialNetwork} chooseSocialNetwork={setSocialNetwork} />
                        <BoxInput text=": عنوان" inputValue={titleContent} chooseValue={setTitleContent} />
                        <BoxInput text=": لینک" inputValue={link} chooseValue={setLink} />
                        <DescriptionContent />
                        <p className="text-right"> : بارگذاری فایل</p>
                    </div>
                </ModalTitleButton>
            </div>
        </>
    )
}
export default AddFreeContent;